import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";

export default [
  {
    prop: "Id",
    name: "NO",
    label: "NO",
    width: 80,
    sortable: true,
    formatter: SLAClolorStatus
  },
  {
    prop: "CustomerName",
    name: "Cliente",
    label: "Cliente",
    minWidth: 300
  },
  {
    prop: "ServiceRequestTypeDescription",
    name: "Solictud",
    label: "Solictud",
    sortable: true,
    minWidth: 200
  },
  {
    prop: "StatusDescription",
    name: "Estado",
    label: "Estado",
    minWidth: 100
  },
  {
    prop: "DeviceQuantity",
    name: "Cantidad",
    label: "Cantidad",
    width: 110,
    sortable: true
  },
  {
    prop: "ProductDescription", //Customer.CustomerService
    name: "Servicio",
    label: "Servicio",
    minWidth: 250,
    sortable: true
  },
  {
    prop: "SellerName",
    name: "Vendedor",
    label: "Vendedor",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "SellerImageUrl"
    }
  },
  {
    prop: "AssignedTechnicianName",
    name: "Tecnico",
    label: "Tecnico",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "AssignedTechnicianImageUrl"
    }
  },
  {
    prop: "RequestDate",
    name: "Creado",
    label: "Creado",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true,
    attrs: {
      onlyDate: true
    }
  },
  {
    prop: "DueDate",
    name: "Limite",
    label: "Limite",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true,
    attrs: {
      onlyDate: true
    }
  },
  {
    prop: "ServiceRequestCloseDate",
    name: "Fecha Cierre",
    label: "Fecha Cierre",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true,
    attrs: {
      onlyDate: true
    }
  },
  {
    prop: "SLAHoursToRespond",
    name: "SLA",
    label: "SLA",
    minWidth: 75,
    sortable: true
  },
  {
    prop: "StatusDescription",
    name: "Estado",
    label: "Estado",
    minWidth: 150,
    sortable: true
  }
];
